var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88 80",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.834 65c-1.667 0-3.083-.583-4.25-1.75-1.167-1.167-1.75-2.583-1.75-4.25V21c0-1.667.583-3.083 1.75-4.25 1.167-1.167 2.583-1.75 4.25-1.75h51.333c1.667 0 3.084.583 4.25 1.75 1.167 1.167 1.75 2.583 1.75 4.25v38c0 1.667-.583 3.083-1.75 4.25-1.166 1.167-2.583 1.75-4.25 1.75H14.834zm25.667-23.167l-26.667-17V59c0 .278.098.514.293.71.194.193.43.29.707.29h51.333a.973.973 0 00.71-.29.973.973 0 00.29-.71V24.833l-26.666 17zm0-5.166L66.667 20H14.334l26.167 16.667zM13.834 24.833V20v39c0 .278.098.514.293.71.194.193.43.29.707.29h-1V24.833z",
    fill: "#12385C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 22,
    r: 16,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 5.333C58.3 5.333 50.835 12.8 50.835 22c0 9.2 7.467 16.667 16.667 16.667 9.2 0 16.666-7.467 16.666-16.667 0-9.2-7.466-16.666-16.666-16.666zM62.985 29.15l-5.983-5.983a1.66 1.66 0 010-2.35c.65-.65 1.7-.65 2.35 0l4.816 4.8L75.634 14.15c.65-.65 1.7-.65 2.35 0 .65.65.65 1.7 0 2.35l-12.65 12.65c-.633.65-1.7.65-2.35 0z",
    fill: "#4CAF50"
  })));
}
export default SvgMailSuccess;